import { createAsyncThunk } from '@reduxjs/toolkit';
import { getDLCForm, createDLCForm as createDLCFormAPI } from 'util/Api/dlcForm';

export const fetchDLCForm = createAsyncThunk(
  'dlc/fetchDLCForm',
  async ({ customerId }, { rejectWithValue }) => {
    try {
      return await getDLCForm({ customerId });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);

export const createDLCForm = createAsyncThunk(
  'dlc/createDLCForm',
  async ({ formData }, { rejectWithValue }) => {
    try {
      return await createDLCFormAPI({ formData });
    } catch (err) {
      return rejectWithValue(err);
    }
  },
);
